import { useState, useEffect } from "react";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifTextArea,
  MotifFormField,
} from "@ey-xd/motif-react";
import {
  isStringHavingSpecialChars,
} from "../../../..//utils/Validator";
import "./RejectModal.scss";

type Props = {
  show: boolean;
  setShow: (show: boolean) => void;
  rejectHandler?: (action: string) => void;
  rejectMessage?: string;
  btnLabel?: string;
  apiErrorMessage?: string;
  onClearApiError?: () => void;
};

export default function RejectModal({
  show,
  setShow,
  rejectHandler,
  rejectMessage,
  btnLabel,
  apiErrorMessage,
  onClearApiError,
}: Props) {
  const [rejectValue, setRejectValue] = useState("");

  useEffect(() => {
    if (show) {
      setRejectValue("");
      onClearApiError?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (isStringHavingSpecialChars(e.target.value)) {
      return;
    }
    onClearApiError?.();
    setRejectValue(e.target.value);
  };

  const handleRejectChange = (rejectMsg: string) => {
    if (rejectHandler) {
      rejectHandler(rejectMsg);
    }
  };

  return (
    <MotifModal show={show} size="default" className="reject-order-modal">
      <MotifModalHeader>
        <span className="header-name">Alert: Rejection reason</span>
      </MotifModalHeader>
      <MotifModalBody>
        <div>
          <p className="motif-body1-default-light rejection-reason">
            {rejectMessage}
          </p>
          <div className="reject-modal-text-area-container">
            <MotifFormField role="group">
              <MotifTextArea
                aria-label="RejectionMessage"
                ariaLabel="RejectionMessage"
                maxLength={250}
                onChange={handleChange}
                placeholder="Type..."
                value={rejectValue}
                hideClearButton={true}
                disabled={false}
              />
              {apiErrorMessage && (
                <div className="reason-error-message">{apiErrorMessage}</div>
              )}
            </MotifFormField>
          </div>
        </div>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          type="button"
          variant="primary"
          onClick={() => {
            onClearApiError?.();
            setShow(false);
          }}
        >
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          type="button"
          warn={true}
          className="rejectBtn"
          disabled={rejectValue.trim() === ""}
          onClick={() => {
            handleRejectChange(rejectValue);
          }}
        >
          {btnLabel}
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}
